import React from 'react';
import {StyleSheet, css} from 'aphrodite';

const paths = {
  web: (
    <>
      <circle cx="12" cy="12" r="8.5" />
      <path d="M3.8 12h16.4M12 3.5c2.2 2.3 3.4 5.1 3.4 8.5S14.2 18.2 12 20.5C9.8 18.2 8.6 15.4 8.6 12S9.8 5.8 12 3.5Z" />
    </>
  ),
  android: (
    <g stroke="none">
      <path fill="#34A853" d="M4.2 3.2 13 12 4.2 20.8c-.45-.34-.7-.89-.7-1.52V4.72c0-.63.25-1.18.7-1.52Z" />
      <path fill="#4285F4" d="m4.2 3.2 10.85 6.25L13 12 4.2 3.2Z" />
      <path fill="#EA4335" d="M4.2 20.8 13 12l2.05 2.55L4.2 20.8Z" />
      <path fill="#FBBC04" d="m15.05 9.45 4.08 2.35c.7.4.7 1.6 0 2l-4.08 2.35L13 12l2.05-2.55Z" />
    </g>
  ),
  huawei: (
    <g fill="#FFFFFF" stroke="none">
      <path d="M11.45 11.7C9.7 9.7 9.2 7.25 10.15 4.1c2.25 1.15 3.05 3.85 1.3 7.6Z" />
      <path d="M12.55 11.7c1.75-2 2.25-4.45 1.3-7.6-2.25 1.15-3.05 3.85-1.3 7.6Z" />
      <path d="M11.15 12.05c-2.6-.65-4.45-2.25-5.55-5.2 2.55-.35 4.75 1.45 5.55 5.2Z" />
      <path d="M12.85 12.05c2.6-.65 4.45-2.25 5.55-5.2-2.55-.35-4.75 1.45-5.55 5.2Z" />
      <path d="M10.95 12.75c-2.7.2-4.95-.75-6.8-3.25 2.35-1.05 5.05.05 6.8 3.25Z" />
      <path d="M13.05 12.75c2.7.2 4.95-.75 6.8-3.25-2.35-1.05-5.05.05-6.8 3.25Z" />
      <path d="M10.8 13.45c-2.35 1.05-4.7.95-7.15-.75 1.75-1.75 4.55-1.65 7.15.75Z" />
      <path d="M13.2 13.45c2.35 1.05 4.7.95 7.15-.75-1.75-1.75-4.55-1.65-7.15.75Z" />
      <path d="M7.7 16.1h8.6v1.35H7.7zM9.15 14.15h5.7v1.2h-5.7z" />
    </g>
  ),
  ios: (
    <>
      <path d="M15.4 12.4c0-2 1.7-3 1.8-3.1-1-1.4-2.5-1.6-3-1.6-1.3-.1-2.5.8-3.1.8-.7 0-1.7-.8-2.8-.8-1.4 0-2.8.9-3.5 2.2-1.5 2.6-.4 6.5 1 8.6.7 1 1.6 2.1 2.7 2 1.1 0 1.5-.7 2.9-.7 1.3 0 1.7.7 2.9.7 1.2 0 2-1 2.7-2.1.8-1.2 1.2-2.4 1.2-2.5-.1 0-2.8-1.1-2.8-3.5Z" />
      <path d="M14.2 6.3c.6-.8 1-1.9.9-3-1 .1-2.1.7-2.8 1.5-.6.7-1.1 1.8-1 2.9 1.1.1 2.2-.5 2.9-1.4Z" />
    </>
  ),
};

export default function PlatformIcon({platform, inverse = false}) {
  return (
    <span
      className={css(
        styles.badge,
        styles[platform],
        inverse && styles.badgeInverse,
      )}
      aria-hidden="true">
      <svg
        className={css(styles.icon)}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.65"
        strokeLinecap="round"
        strokeLinejoin="round">
        {paths[platform]}
      </svg>
    </span>
  );
}

const styles = StyleSheet.create({
  badge: {
    width: '38px',
    height: '38px',
    borderRadius: '11px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    color: '#0F3D2E',
    backgroundColor: '#F4EBD8',
    border: '1px solid rgba(201, 161, 74, 0.55)',
  },
  badgeInverse: {
    color: '#FFFDF7',
    backgroundColor: '#0F3D2E',
    borderColor: 'rgba(15, 61, 46, 0.22)',
  },
  web: {
    color: '#0F3D2E',
    backgroundColor: '#FFF7E6',
    borderColor: '#C9A14A',
  },
  android: {
    backgroundColor: '#FFFFFF',
    borderColor: '#D9DDE3',
  },
  huawei: {
    backgroundColor: '#CF0A2C',
    borderColor: '#CF0A2C',
  },
  ios: {
    color: '#1D1D1F',
    backgroundColor: '#F2F2F4',
    borderColor: '#CFCFD4',
  },
  icon: {
    width: '22px',
    height: '22px',
    display: 'block',
  },
});
